import { create } from 'zustand';

type ModalStore = {
  isSizeModalOpen: boolean;
  toggleSizeModal: (state: boolean) => void;
};

const useSizeModal = create<ModalStore>((set) => ({
  isSizeModalOpen: false,
  toggleSizeModal: (state: boolean) => set({ isSizeModalOpen: state }),
}));

export { useSizeModal };
